// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type WorkspaceManageTopicsAndThemesQueryVariables = PrivateSchemaTypes.Exact<{
  workspaceId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type WorkspaceManageTopicsAndThemesQuery = (
  { __typename?: 'Query' }
  & { workspace?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'WorkspaceModelAsCollaborator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCollaborator, 'id' | 'description' | 'name'>
    & { coverImage?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'DocumentModel' }
      & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
      & { imageVariants: Array<(
        { __typename?: 'ImageVariantModel' }
        & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl'>
      )> }
    )>, topics: Array<(
      { __typename?: 'TopicModelAsEditor' }
      & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'order' | 'id' | 'currentTitle' | 'deleted_at' | 'created_at' | 'number_rated' | 'total_rating'>
      & { currentTopicVersion?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'TopicVersionModel' }
        & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'title' | 'readDurationMins' | 'summary' | 'topic_type'>
      )>, author: (
        { __typename?: 'UserModelPublicBase' }
        & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'email' | 'image_url' | 'display_name' | 'profile_img_url'>
      ), coverImage?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'DocumentModel' }
        & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
        & { imageVariants: Array<(
          { __typename?: 'ImageVariantModel' }
          & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl'>
        )> }
      )> }
    ) | (
      { __typename?: 'TopicModelAsMember' }
      & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id' | 'currentTitle' | 'deleted_at' | 'created_at' | 'number_rated' | 'total_rating'>
      & { currentTopicVersion?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'TopicVersionModel' }
        & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'title' | 'readDurationMins' | 'summary' | 'topic_type'>
      )>, author: (
        { __typename?: 'UserModelPublicBase' }
        & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'email' | 'image_url' | 'display_name' | 'profile_img_url'>
      ), coverImage?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'DocumentModel' }
        & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
        & { imageVariants: Array<(
          { __typename?: 'ImageVariantModel' }
          & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl'>
        )> }
      )> }
    )>, themes: Array<(
      { __typename?: 'ThemeModelAsEditor' }
      & Pick<PrivateSchemaTypes.ThemeModelAsEditor, 'order' | 'workspace_id' | 'id' | 'title'>
      & { topics: Array<(
        { __typename?: 'TopicModelAsEditor' }
        & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'order' | 'id' | 'currentTitle'>
        & { author: (
          { __typename?: 'UserModelPublicBase' }
          & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'email' | 'image_url' | 'display_name' | 'profile_img_url'>
        ), currentTopicVersion?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'TopicVersionModel' }
          & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'title' | 'readDurationMins' | 'summary'>
        )>, coverImage?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'DocumentModel' }
          & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
          & { imageVariants: Array<(
            { __typename?: 'ImageVariantModel' }
            & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl'>
          )> }
        )> }
      ) | (
        { __typename?: 'TopicModelAsMember' }
        & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id' | 'currentTitle'>
        & { author: (
          { __typename?: 'UserModelPublicBase' }
          & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'email' | 'image_url' | 'display_name' | 'profile_img_url'>
        ), currentTopicVersion?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'TopicVersionModel' }
          & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'title' | 'readDurationMins' | 'summary'>
        )>, coverImage?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'DocumentModel' }
          & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
          & { imageVariants: Array<(
            { __typename?: 'ImageVariantModel' }
            & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl'>
          )> }
        )> }
      )> }
    ) | (
      { __typename?: 'ThemeModelAsMember' }
      & Pick<PrivateSchemaTypes.ThemeModelAsMember, 'id' | 'title'>
      & { topics: Array<(
        { __typename?: 'TopicModelAsEditor' }
        & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'order' | 'id' | 'currentTitle'>
        & { author: (
          { __typename?: 'UserModelPublicBase' }
          & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'email' | 'image_url' | 'display_name' | 'profile_img_url'>
        ), currentTopicVersion?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'TopicVersionModel' }
          & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'title' | 'readDurationMins' | 'summary'>
        )>, coverImage?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'DocumentModel' }
          & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
          & { imageVariants: Array<(
            { __typename?: 'ImageVariantModel' }
            & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl'>
          )> }
        )> }
      ) | (
        { __typename?: 'TopicModelAsMember' }
        & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id' | 'currentTitle'>
        & { author: (
          { __typename?: 'UserModelPublicBase' }
          & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'email' | 'image_url' | 'display_name' | 'profile_img_url'>
        ), currentTopicVersion?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'TopicVersionModel' }
          & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'title' | 'readDurationMins' | 'summary'>
        )>, coverImage?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'DocumentModel' }
          & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
          & { imageVariants: Array<(
            { __typename?: 'ImageVariantModel' }
            & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl'>
          )> }
        )> }
      )> }
    )> }
  ) | (
    { __typename?: 'WorkspaceModelAsCoordinator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCoordinator, 'id' | 'description' | 'name'>
    & { coverImage?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'DocumentModel' }
      & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
      & { imageVariants: Array<(
        { __typename?: 'ImageVariantModel' }
        & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl'>
      )> }
    )>, topics: Array<(
      { __typename?: 'TopicModelAsEditor' }
      & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'order' | 'id' | 'currentTitle' | 'deleted_at' | 'created_at' | 'number_rated' | 'total_rating'>
      & { currentTopicVersion?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'TopicVersionModel' }
        & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'title' | 'readDurationMins' | 'summary' | 'topic_type'>
      )>, author: (
        { __typename?: 'UserModelPublicBase' }
        & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'email' | 'image_url' | 'display_name' | 'profile_img_url'>
      ), coverImage?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'DocumentModel' }
        & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
        & { imageVariants: Array<(
          { __typename?: 'ImageVariantModel' }
          & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl'>
        )> }
      )> }
    ) | (
      { __typename?: 'TopicModelAsMember' }
      & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id' | 'currentTitle' | 'deleted_at' | 'created_at' | 'number_rated' | 'total_rating'>
      & { currentTopicVersion?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'TopicVersionModel' }
        & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'title' | 'readDurationMins' | 'summary' | 'topic_type'>
      )>, author: (
        { __typename?: 'UserModelPublicBase' }
        & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'email' | 'image_url' | 'display_name' | 'profile_img_url'>
      ), coverImage?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'DocumentModel' }
        & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
        & { imageVariants: Array<(
          { __typename?: 'ImageVariantModel' }
          & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl'>
        )> }
      )> }
    )>, themes: Array<(
      { __typename?: 'ThemeModelAsEditor' }
      & Pick<PrivateSchemaTypes.ThemeModelAsEditor, 'order' | 'workspace_id' | 'id' | 'title'>
      & { topics: Array<(
        { __typename?: 'TopicModelAsEditor' }
        & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'order' | 'id' | 'currentTitle'>
        & { author: (
          { __typename?: 'UserModelPublicBase' }
          & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'email' | 'image_url' | 'display_name' | 'profile_img_url'>
        ), currentTopicVersion?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'TopicVersionModel' }
          & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'title' | 'readDurationMins' | 'summary'>
        )>, coverImage?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'DocumentModel' }
          & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
          & { imageVariants: Array<(
            { __typename?: 'ImageVariantModel' }
            & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl'>
          )> }
        )> }
      ) | (
        { __typename?: 'TopicModelAsMember' }
        & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id' | 'currentTitle'>
        & { author: (
          { __typename?: 'UserModelPublicBase' }
          & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'email' | 'image_url' | 'display_name' | 'profile_img_url'>
        ), currentTopicVersion?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'TopicVersionModel' }
          & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'title' | 'readDurationMins' | 'summary'>
        )>, coverImage?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'DocumentModel' }
          & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
          & { imageVariants: Array<(
            { __typename?: 'ImageVariantModel' }
            & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl'>
          )> }
        )> }
      )> }
    ) | (
      { __typename?: 'ThemeModelAsMember' }
      & Pick<PrivateSchemaTypes.ThemeModelAsMember, 'id' | 'title'>
      & { topics: Array<(
        { __typename?: 'TopicModelAsEditor' }
        & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'order' | 'id' | 'currentTitle'>
        & { author: (
          { __typename?: 'UserModelPublicBase' }
          & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'email' | 'image_url' | 'display_name' | 'profile_img_url'>
        ), currentTopicVersion?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'TopicVersionModel' }
          & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'title' | 'readDurationMins' | 'summary'>
        )>, coverImage?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'DocumentModel' }
          & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
          & { imageVariants: Array<(
            { __typename?: 'ImageVariantModel' }
            & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl'>
          )> }
        )> }
      ) | (
        { __typename?: 'TopicModelAsMember' }
        & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id' | 'currentTitle'>
        & { author: (
          { __typename?: 'UserModelPublicBase' }
          & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'email' | 'image_url' | 'display_name' | 'profile_img_url'>
        ), currentTopicVersion?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'TopicVersionModel' }
          & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'title' | 'readDurationMins' | 'summary'>
        )>, coverImage?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'DocumentModel' }
          & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
          & { imageVariants: Array<(
            { __typename?: 'ImageVariantModel' }
            & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl'>
          )> }
        )> }
      )> }
    )> }
  ) | (
    { __typename?: 'WorkspaceModelAsMember' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsMember, 'id' | 'description' | 'name'>
    & { coverImage?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'DocumentModel' }
      & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
      & { imageVariants: Array<(
        { __typename?: 'ImageVariantModel' }
        & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl'>
      )> }
    )>, topics: Array<(
      { __typename?: 'TopicModelAsEditor' }
      & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'order' | 'id' | 'currentTitle' | 'deleted_at' | 'created_at' | 'number_rated' | 'total_rating'>
      & { currentTopicVersion?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'TopicVersionModel' }
        & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'title' | 'readDurationMins' | 'summary' | 'topic_type'>
      )>, author: (
        { __typename?: 'UserModelPublicBase' }
        & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'email' | 'image_url' | 'display_name' | 'profile_img_url'>
      ), coverImage?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'DocumentModel' }
        & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
        & { imageVariants: Array<(
          { __typename?: 'ImageVariantModel' }
          & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl'>
        )> }
      )> }
    ) | (
      { __typename?: 'TopicModelAsMember' }
      & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id' | 'currentTitle' | 'deleted_at' | 'created_at' | 'number_rated' | 'total_rating'>
      & { currentTopicVersion?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'TopicVersionModel' }
        & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'title' | 'readDurationMins' | 'summary' | 'topic_type'>
      )>, author: (
        { __typename?: 'UserModelPublicBase' }
        & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'email' | 'image_url' | 'display_name' | 'profile_img_url'>
      ), coverImage?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'DocumentModel' }
        & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
        & { imageVariants: Array<(
          { __typename?: 'ImageVariantModel' }
          & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl'>
        )> }
      )> }
    )>, themes: Array<(
      { __typename?: 'ThemeModelAsEditor' }
      & Pick<PrivateSchemaTypes.ThemeModelAsEditor, 'order' | 'workspace_id' | 'id' | 'title'>
      & { topics: Array<(
        { __typename?: 'TopicModelAsEditor' }
        & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'order' | 'id' | 'currentTitle'>
        & { author: (
          { __typename?: 'UserModelPublicBase' }
          & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'email' | 'image_url' | 'display_name' | 'profile_img_url'>
        ), currentTopicVersion?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'TopicVersionModel' }
          & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'title' | 'readDurationMins' | 'summary'>
        )>, coverImage?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'DocumentModel' }
          & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
          & { imageVariants: Array<(
            { __typename?: 'ImageVariantModel' }
            & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl'>
          )> }
        )> }
      ) | (
        { __typename?: 'TopicModelAsMember' }
        & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id' | 'currentTitle'>
        & { author: (
          { __typename?: 'UserModelPublicBase' }
          & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'email' | 'image_url' | 'display_name' | 'profile_img_url'>
        ), currentTopicVersion?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'TopicVersionModel' }
          & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'title' | 'readDurationMins' | 'summary'>
        )>, coverImage?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'DocumentModel' }
          & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
          & { imageVariants: Array<(
            { __typename?: 'ImageVariantModel' }
            & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl'>
          )> }
        )> }
      )> }
    ) | (
      { __typename?: 'ThemeModelAsMember' }
      & Pick<PrivateSchemaTypes.ThemeModelAsMember, 'id' | 'title'>
      & { topics: Array<(
        { __typename?: 'TopicModelAsEditor' }
        & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'order' | 'id' | 'currentTitle'>
        & { author: (
          { __typename?: 'UserModelPublicBase' }
          & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'email' | 'image_url' | 'display_name' | 'profile_img_url'>
        ), currentTopicVersion?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'TopicVersionModel' }
          & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'title' | 'readDurationMins' | 'summary'>
        )>, coverImage?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'DocumentModel' }
          & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
          & { imageVariants: Array<(
            { __typename?: 'ImageVariantModel' }
            & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl'>
          )> }
        )> }
      ) | (
        { __typename?: 'TopicModelAsMember' }
        & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id' | 'currentTitle'>
        & { author: (
          { __typename?: 'UserModelPublicBase' }
          & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'email' | 'image_url' | 'display_name' | 'profile_img_url'>
        ), currentTopicVersion?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'TopicVersionModel' }
          & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'title' | 'readDurationMins' | 'summary'>
        )>, coverImage?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'DocumentModel' }
          & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
          & { imageVariants: Array<(
            { __typename?: 'ImageVariantModel' }
            & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl'>
          )> }
        )> }
      )> }
    )> }
  )> }
);

export type ReorderTopicsInWorkspaceMutationVariables = PrivateSchemaTypes.Exact<{
  workspaceId: PrivateSchemaTypes.Scalars['PositiveInt'];
  topicIds: Array<PrivateSchemaTypes.Scalars['PositiveInt']> | PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type ReorderTopicsInWorkspaceMutation = (
  { __typename?: 'Mutation' }
  & { workspace?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'WorkspaceModelAsCollaborator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCollaborator, 'id' | 'reorderTopics'>
  ) | (
    { __typename?: 'WorkspaceModelAsCoordinator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCoordinator, 'id' | 'reorderTopics'>
  ) | (
    { __typename?: 'WorkspaceModelAsMember' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsMember, 'id'>
  )> }
);


export const WorkspaceManageTopicsAndThemesDocument = gql`
    query workspaceManageTopicsAndThemes($workspaceId: PositiveInt!) {
  workspace(id: $workspaceId) {
    id
    description
    name
    coverImage {
      id
      cdnUrl
      imageVariants {
        cdnUrl
      }
    }
    topics(filters: [{name: noTheme}]) {
      id
      currentTitle
      deleted_at
      created_at
      number_rated
      total_rating
      currentTopicVersion {
        id
        title
        readDurationMins
        summary
        topic_type
      }
      author {
        id
        email
        image_url
        display_name
        profile_img_url
      }
      coverImage {
        id
        cdnUrl
        imageVariants {
          cdnUrl
        }
      }
      ... on TopicModelAsEditor {
        order
      }
    }
    themes {
      id
      title
      ... on ThemeModelAsEditor {
        order
        workspace_id
      }
      topics {
        id
        currentTitle
        author {
          id
          email
          image_url
          display_name
          profile_img_url
        }
        currentTopicVersion {
          id
          title
          readDurationMins
          summary
        }
        coverImage {
          id
          cdnUrl
          imageVariants {
            cdnUrl
          }
        }
        ... on TopicModelAsEditor {
          order
        }
      }
    }
  }
}
    `;

/**
 * __useWorkspaceManageTopicsAndThemesQuery__
 *
 * To run a query within a React component, call `useWorkspaceManageTopicsAndThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceManageTopicsAndThemesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceManageTopicsAndThemesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useWorkspaceManageTopicsAndThemesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WorkspaceManageTopicsAndThemesQuery, WorkspaceManageTopicsAndThemesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WorkspaceManageTopicsAndThemesQuery, WorkspaceManageTopicsAndThemesQueryVariables>(WorkspaceManageTopicsAndThemesDocument, options);
      }
export function useWorkspaceManageTopicsAndThemesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WorkspaceManageTopicsAndThemesQuery, WorkspaceManageTopicsAndThemesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WorkspaceManageTopicsAndThemesQuery, WorkspaceManageTopicsAndThemesQueryVariables>(WorkspaceManageTopicsAndThemesDocument, options);
        }
export type WorkspaceManageTopicsAndThemesQueryHookResult = ReturnType<typeof useWorkspaceManageTopicsAndThemesQuery>;
export type WorkspaceManageTopicsAndThemesLazyQueryHookResult = ReturnType<typeof useWorkspaceManageTopicsAndThemesLazyQuery>;
export type WorkspaceManageTopicsAndThemesQueryResult = Apollo.QueryResult<WorkspaceManageTopicsAndThemesQuery, WorkspaceManageTopicsAndThemesQueryVariables>;
export const ReorderTopicsInWorkspaceDocument = gql`
    mutation ReorderTopicsInWorkspace($workspaceId: PositiveInt!, $topicIds: [PositiveInt!]!) {
  workspace(id: $workspaceId) {
    id
    ... on WorkspaceModelAsCoordinator {
      id
      reorderTopics(topicIds: $topicIds)
    }
    ... on WorkspaceModelAsCollaborator {
      id
      reorderTopics(topicIds: $topicIds)
    }
  }
}
    `;
export type ReorderTopicsInWorkspaceMutationFn = Apollo.MutationFunction<ReorderTopicsInWorkspaceMutation, ReorderTopicsInWorkspaceMutationVariables>;

/**
 * __useReorderTopicsInWorkspaceMutation__
 *
 * To run a mutation, you first call `useReorderTopicsInWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderTopicsInWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderTopicsInWorkspaceMutation, { data, loading, error }] = useReorderTopicsInWorkspaceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      topicIds: // value for 'topicIds'
 *   },
 * });
 */
export function useReorderTopicsInWorkspaceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReorderTopicsInWorkspaceMutation, ReorderTopicsInWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReorderTopicsInWorkspaceMutation, ReorderTopicsInWorkspaceMutationVariables>(ReorderTopicsInWorkspaceDocument, options);
      }
export type ReorderTopicsInWorkspaceMutationHookResult = ReturnType<typeof useReorderTopicsInWorkspaceMutation>;
export type ReorderTopicsInWorkspaceMutationResult = Apollo.MutationResult<ReorderTopicsInWorkspaceMutation>;
export type ReorderTopicsInWorkspaceMutationOptions = Apollo.BaseMutationOptions<ReorderTopicsInWorkspaceMutation, ReorderTopicsInWorkspaceMutationVariables>;